var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7937 8.00014C15.7937 12.4184 12.2581 16 7.89697 16C3.53585 16 0 12.4184 0 8.00014C0 3.58192 3.53558 0 7.89697 0C12.2584 0 15.7937 3.58192 15.7937 8.00014Z",
    fill: "url(#paint0_linear_763_5372)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4566 8.00014C24.4566 12.1589 22.6888 15.5316 20.5081 15.5316C18.3275 15.5316 16.5597 12.1589 16.5597 8.00014C16.5597 3.84134 18.3272 0.468628 20.5079 0.468628C22.6886 0.468628 24.4564 3.84026 24.4564 8.00014",
    fill: "url(#paint1_linear_763_5372)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.00014C28 11.7254 27.3784 14.7472 26.6113 14.7472C25.8443 14.7472 25.2229 11.7262 25.2229 8.00014C25.2229 4.27406 25.8445 1.25309 26.6113 1.25309C27.3781 1.25309 28 4.27379 28 8.00014Z",
    fill: "url(#paint2_linear_763_5372)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_763_5372",
    x1: 0,
    y1: 8,
    x2: 28,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_763_5372",
    x1: 0,
    y1: 8,
    x2: 28,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_763_5372",
    x1: 0,
    y1: 8,
    x2: 28,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d8568cae85198a04ec27dd8db27fba95.svg";
export { ForwardRef as ReactComponent };